<script setup>
import ErrorSnackbar from '@/components/snackbar/ErrorSnackbar.vue'
import SuccessSnackbar from '@/components/snackbar/SuccessSnackbar.vue'
import { useEventsBus } from '@haskoning/vue-component-library'
import { ref, watch } from 'vue'

const { bus } = useEventsBus()
const successSnackbars = ref([])
const errorSnackbars = ref([])
const timeout = 4000
const snackBarMargin = 60

watch(
  () => bus.value.get('error'),
  (error) => {
    updateMargin()
    errorSnackbars.value.unshift({
      value: true,
      margin: 15,
      timeout: timeout,
      message: error[0]
    })
  }
)

watch(
  () => bus.value.get('success'),
  (success) => {
    updateMargin()
    successSnackbars.value.unshift({
      value: true,
      margin: 15,
      timeout: timeout,
      message: success[0]
    })
  }
)

function checkAvailableSpotBottom(snackbars) {
  return snackbars.map((snackbar) => snackbar.margin).includes(0)
}

function updateMargin() {
  let snackbars = successSnackbars.value
    .filter((snackbar) => snackbar.value)
    .concat(errorSnackbars.value.filter((snackbar) => snackbar.value))
  if (checkAvailableSpotBottom(snackbars)) {
    snackbars.forEach((snackbar) => {
      snackbar.margin += snackBarMargin
    })
  }
}
</script>

<template>
  <div>
    <div v-for="snackbar in successSnackbars" :key="snackbar.message">
      <SuccessSnackbar
        :success="snackbar.message"
        :snackbar="snackbar.value"
        :timeout="snackbar.timeout"
        :margin="snackbar.margin"
        @set="snackbar.value = false"
      />
    </div>
    <div v-for="snackbar in errorSnackbars" :key="snackbar.message">
      <ErrorSnackbar
        :error="snackbar.message"
        :snackbar="snackbar.value"
        :timeout="snackbar.timeout"
        :margin="snackbar.margin"
        @set="snackbar.value = false"
      />
    </div>
  </div>
</template>
